import HeaderWithBackAndTitle from "@components/HeaderWithBackAndTitle";
import * as React from "react";
import { getAllCpDbs } from "@services/api";
import t from "@constants/localization";
import NoDeliveryBoys from "./NoDeliveryBoys";

const CpDeliveryBoys = ({ navigation, route }) => {
  React.useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const PATH = "screens/CpDeliveryBoys/index";

  const fetchData = async () => {
    try {
      const { data } = await getAllCpDbs();
      if (data?.dbs?.length > 0) {
        navigation.replace("CreateDbOrList");
      }
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <>
      <HeaderWithBackAndTitle
        headertitle={t(`${PATH}/headerTitle`)}
        headerColor="#fff"
        hideShadow={false}
        navigation={navigation}
        route={route}
      />
      <NoDeliveryBoys navigation={navigation} />
    </>
  );
};

export default CpDeliveryBoys;
